import {
  FileEdit,
  Clock,
  CheckCircle2,
  XCircle,
  PauseCircle,
  type LucideIcon,
} from "lucide-react";
import { ObjectiveCategory, ObjectiveStatus } from "@/types";

export const OBJECTIVE_STATUSES = Object.values(ObjectiveStatus) as ObjectiveStatus[];

export const OBJECTIVE_CATEGORIES: ObjectiveCategory[] = ["fintech", "ai", "company"];

/** Shared by Objective (3 lanes) and PPP (fintech | ai) badges. */
export const CATEGORY_LABEL: Record<ObjectiveCategory, string> = {
  fintech: "Fintech",
  ai: "AI",
  company: "Company",
};

export const CATEGORY_BADGE: Record<ObjectiveCategory, string> = {
  fintech: "bg-green-100 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-800",
  ai: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-800",
  company: "bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-950 dark:text-purple-300 dark:border-purple-800",
};

/** One definition of "% complete" for every OKR progress bar/label. */
export const okrPct = (progress: number, target: number): number =>
  target > 0 ? Math.min(100, Math.round((progress / target) * 100)) : 0;

// Alias for KR (same statuses as Objective)
export const KR_STATUSES = OBJECTIVE_STATUSES;

export const STATUS_CONFIG: Record<ObjectiveStatus, { label: string; icon: LucideIcon; className: string; dotColor: string }> = {
  [ObjectiveStatus.DRAFT]: { label: "Draft", icon: FileEdit, className: "bg-muted text-muted-foreground", dotColor: "bg-muted-foreground" },
  [ObjectiveStatus.ACTIVE]: { label: "Active", icon: Clock, className: "bg-blue-500/10 text-blue-500", dotColor: "bg-blue-500" },
  [ObjectiveStatus.COMPLETED]: { label: "Completed", icon: CheckCircle2, className: "bg-emerald-500/10 text-emerald-500", dotColor: "bg-emerald-500" },
  [ObjectiveStatus.CANCELLED]: { label: "Cancelled", icon: XCircle, className: "bg-destructive/10 text-destructive", dotColor: "bg-destructive" },
  [ObjectiveStatus.ON_HOLD]: { label: "On Hold", icon: PauseCircle, className: "bg-amber-500/10 text-amber-500", dotColor: "bg-amber-500" },
};
